import React from 'react'
import { BaseFieldProps } from './index'
import styled from 'particles/themes/styled'
import FieldTitleAndSubTitle from './FieldTitleAndSubTitle'
import { FormikCheckboxGroup, OptionState } from 'particles/Checkbox/Group'
import Label from 'particles/Label'
interface CheckBoxMultiGroupFieldProps extends BaseFieldProps {
    onClose?: () => void
    className?: string
    options: OptionState<number>[]
    isDisplayRow?: boolean
    notice?: Function // eslint-disable-line @typescript-eslint/ban-types
    onClick?: any
    isReadOnly?: boolean
    subLabel?: string
}

const CheckBoxMultiGroupField: React.FC<CheckBoxMultiGroupFieldProps> = ({
    name = '',
    options,
    title,
    subtitle,
    isRequired = false,
    className,
    onClose,
    isDisplayRow = false,
    onClick,
    isReadOnly = false,
    isDisable = false,
    subLabel,
    identifier,
}) => {
    return (
        <div className={className}>
            <FieldTitleAndSubTitle
                isRequired={isRequired}
                onClose={onClose}
                title={title}
                subtitle={subtitle}
                isReadOnly={isReadOnly}
                identifier={identifier}
            />
            {subLabel && <Label title={subLabel} isRequired={false} className="sub-label" />}

            <FormikCheckboxGroup
                name={name}
                options={options}
                orientation={isDisplayRow ? 'horizontal' : 'vertical'}
                onClick={onClick}
                isReadOnly={isReadOnly}
                isDisabled={isDisable}
                size="s"
            />
        </div>
    )
}
export default styled(CheckBoxMultiGroupField)`
    .field-sub-title {
        margin-bottom: 24px;
    }
    .sub-label {
        margin-bottom: 8px;
    }
`
